<script setup lang="ts">
import {ref, computed, watch, PropType} from 'vue';
import date from "@/helper/datetime/date";
import {floatFormat} from "@/helper/amountFormatter";
import {Employee} from "@/graphql/generated/graphql";
import {IonChip} from "@ionic/vue";
import {compact} from "openai/internal/qs/utils";
import {warning} from "ionicons/icons";

const props = defineProps({
    employee: {
        type: Object as PropType<Employee|undefined>,
        required: true,
        default: undefined
    },
    compact: {
        type: Boolean,
        required: false,
        default: false
    },
    chipped: {
        type: Boolean,
        default: true
    }
})

const azkValue = computed(() => props.employee?.aZK?.value || 0)
const azkValid = computed(() => props.employee?.aZK?.validMonth || undefined)

const text = computed(() => props.compact
    ? `AZK: ${floatFormat(azkValue.value)}h`
    : `Aktuelles AZK: ${floatFormat(azkValue.value)}h (Stand ${azkValid.value ? date.formatKapitelDate(azkValid.value, 'MMMM y') : 'unbekannt'})`
)

</script>

<template>
    <IonChip :color="warning" v-if="chipped">{{text}}</IonChip>
    <span v-else>{{text}}</span>
</template>

<style lang="scss">
</style>
